<template>
  <label class="cb-lapel-parent row" v-if="parent_data" :class="{ 'can-change': is_editable }">
    <input type="checkbox" v-model="checked" class="el-checkbox__checkbox" />
    <span v-if="label" class="el-checkbox__label self-center">{{ label }}</span>
  </label>
</template>

<script>
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-checkbox",
	mixins: [ElementMixin],
	props: {
		label: { default: "" },
	},
	computed: {
		checked: {
			get () {
				return this.parent_data[this.property];
			},
			set (new_value) {
				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: this.property,
					value: new_value,
				});
			},
		},
	},
};
</script>

<style scoped>
.el-checkbox__checkbox {
  margin-right: 10px;
}

.el-checkbox__label {
  font-weight: bold;
  text-transform: none;
}
</style>